import * as Yup from 'yup';
import { REQUIRED_ERROR_MSG, SERIES_CREATION_AT_LEAST_ONE_EXERCISE } from 'utils/constants/errors';
import { CUSTOM_REP, METHOD } from 'utils/constants/workouts';

export const createWorkoutSchema = Yup.object().shape({
  name: Yup.string().required(REQUIRED_ERROR_MSG),
  level: Yup.string().required(REQUIRED_ERROR_MSG),
  phase: Yup.number().required(REQUIRED_ERROR_MSG)
});

export const renameWorkoutSchema = Yup.object().shape({
  name: Yup.string().required(REQUIRED_ERROR_MSG)
});

export const createSeriesSchema = Yup.object().shape({
  seriesName: Yup.string().required(REQUIRED_ERROR_MSG),
  exerciesNum: Yup.number().required(REQUIRED_ERROR_MSG),
  repsType: Yup.string().required(REQUIRED_ERROR_MSG),
  sets: Yup.number().required(REQUIRED_ERROR_MSG),
  ExerciesList: Yup.array()
    .min(1, SERIES_CREATION_AT_LEAST_ONE_EXERCISE)
    .test('nullValues', SERIES_CREATION_AT_LEAST_ONE_EXERCISE, array => {
      return ([...array].filter(ele =>  ele && ele.exercise_id)).length > 0;
    })
    .of(
      Yup.object().nullable().shape({
        weight: Yup
          .number()
          .min(1, "Weight must be greater than or equal to 1")
          .max(500, "Weight must be less than or equal to 500")
          .required(REQUIRED_ERROR_MSG),
        tempo: Yup
          .number()
          .positive("tempo must be a positive number")
          .test('len', 'Must be exactly 4 digits', val => val ? val.toString().length === 4 : true)
          .required(REQUIRED_ERROR_MSG),
        rest: Yup.number().positive("Rest must be a positive number").required(REQUIRED_ERROR_MSG)
      })
    ),
  reps: Yup.number().min(1).max(100),
  method: Yup.string()
}).test('', null, values => {
  if (values.repsType === CUSTOM_REP && !values.reps) {
    return new Yup.ValidationError(
      REQUIRED_ERROR_MSG,
      null,
      'dependentFieldRequired'
    );
  } else if (values.repsType === METHOD  && !values.method) {
    return new Yup.ValidationError(
      'you have to select one method!',
      null,
      'dependentFieldRequired'
    );
  }

  return true;
});
